"use client";

import React, { useEffect, useState } from "react";
import YourBusinessWorkingTime from "./YourBusinessWorkingTime";
import YourBusinessInfo from "./YourBusinessInfo";
import YourBusinessWorkers from "./YourBusinessWorkers";
import YourBusinessServices from "./YourBusinessServices";
import YourBusinessDescription from "./YourBusinessDescription";

import { REST_API_URL } from "../../api/config";
import { buildHeaders } from "../../api/buildHeaders";
const API_URL = REST_API_URL;

export default function YourBusinessDashboard() {
  const [userType, setUserType] = useState(null);

  useEffect(() => {
    const token =
      localStorage.getItem("accessToken") ||
      sessionStorage.getItem("accessToken");

    if (!token) return;

    const fetchUserType = async () => {
      try {
        const res = await fetch(`${API_URL}/auth/userinfo/`, {
          headers: buildHeaders(),
        });

        if (!res.ok) throw new Error(`HTTP ${res.status}`);
        const data = await res.json();
        setUserType(data?.user?.status || null);
      } catch (err) {
        console.error("❌ Error fetching user type:", err);
      }
    };

    fetchUserType();
  }, []);

  return (
    <main className="p-4 sm:p-6 bg-[#F7F8FA] min-h-screen space-y-4 sm:space-y-6">
      <section>
        <YourBusinessWorkingTime />
      </section>

      {userType !== "worker" && (
        <section>
          <YourBusinessDescription />
        </section>
      )}

      <section className="flex flex-col lg:flex-row gap-6">
        <div className={`flex flex-col flex-[2] space-y-6 min-w-0`}>
          <YourBusinessInfo />
          <YourBusinessServices />
        </div>

        {userType === "salon" && (
          <div className="flex-[1] min-w-0">
            <YourBusinessWorkers />
          </div>
        )}
      </section>
    </main>
  );
}

